import { render, staticRenderFns } from "./formError.vue?vue&type=template&id=38507ab2"
import script from "./formError.vue?vue&type=script&lang=js"
export * from "./formError.vue?vue&type=script&lang=js"
import style0 from "./formError.vue?vue&type=style&index=0&id=38507ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports